import React from 'react';
import { QuotaRecalculeInfo } from './QuotaRecalculeInfo';
import DateHelpers from '../../../../../../../../core/helpers/DateHelper';
import {
  ContainerCardNotes,
  ContainerGroup,
  ContainerModuleName,
  ContainerNotes,
  ContainerNotesLeft
} from './styled';
import { Line } from '@/presentation/modules/events/modules/eventDetail/components/InPersonEventBox';
import useProfile from '@/presentation/hooks/useProfile';

interface DatesForRecalculeProps {
  datesModule: any;
  periodId: string;
}

const DatesForRecalcule = (props: DatesForRecalculeProps) => {
  const { datesModule, periodId } = props;
  const { transformId } = useProfile();
  const formatDate = (date: number) =>
    `${DateHelpers.formatDateExtended(
      date
    )} del ${DateHelpers.getYearWithFormat(date)}`;

  return (
    <>
      {datesModule?.length > 1 ? (
        // Esto es para CGT (tiene cursos modulares)
        <ContainerGroup>
          <ContainerCardNotes>
            <ContainerModuleName>
              <strong>Cursos de Módulo 1</strong>
              <ContainerNotesLeft>
                <span>{formatDate(datesModule[0]?.deadlineWithRecalc)}.</span>
                <br />
                <span>
                  Con recálculo de cuotas <b>(*).</b>
                </span>
                <Line style={{ background: '#7A959F', margin: '10px 0px' }} />
                <span>
                  {formatDate(datesModule[0]?.deadlineWithoutRecalc)}.
                </span>
                <br />
                <span>Sin recálculo de cuotas.</span>
              </ContainerNotesLeft>
            </ContainerModuleName>
            <ContainerModuleName>
              <strong>Cursos de Módulo 2</strong>
              <ContainerNotes>
                <span>{formatDate(datesModule[1].deadlineWithRecalc)}.</span>
                <br />
                <span>Con recálculo de cuotas.</span>
                <Line style={{ background: '#7A959F', margin: '10px 0px' }} />
                <span>{formatDate(datesModule[1].deadlineWithoutRecalc)}.</span>
                <br />
                <span>
                  Sin recálculo de cuotas <b>(*).</b>
                </span>
              </ContainerNotes>
            </ContainerModuleName>
          </ContainerCardNotes>
          <p style={{ marginTop: '8px' }}>(*) Son para cursos bimodulares.</p>

          <QuotaRecalculeInfo />
        </ContainerGroup>
      ) : (
        // Esto es para Pregrado normal
        <ContainerGroup>
          {periodId && <p>{transformId(periodId).replace(/Ciclo/g, '')}</p>}

          <ContainerCardNotes>
            <ContainerNotesLeft>
              <span>{formatDate(datesModule[0]?.deadlineWithRecalc)}.</span>
              <br />
              <span>Con recálculo de cuotas.</span>
            </ContainerNotesLeft>
            <ContainerNotes>
              <span>{formatDate(datesModule[0]?.deadlineWithoutRecalc)}.</span>
              <br />
              <span>Sin recálculo de cuotas.</span>
            </ContainerNotes>
          </ContainerCardNotes>
          <QuotaRecalculeInfo />
        </ContainerGroup>
      )}
    </>
  );
};

export { DatesForRecalcule };
